// add colors, fonts, fontSizes, space, etc
const theme = {}

export default theme
